export default function Modal ({setModal, children}) {

	function doCloseModal () {
		setModal('');
	}

	return (
		<div className="modal fade show d-block">
			<div className="modal-dialog modal-lg">
				<div className="modal-content px-4">
					<button type="button"
					        className="btn-close position-absolute"
					        style={{
						        top: '1rem',
						        right: '1rem',
						        zIndex: 1
					        }}
					        onClick={doCloseModal}
					></button>
					<div className="modal-body">
						{children}
					</div>
				</div>
			</div>
			<div className="modal-backdrop fade show" style={{
				zIndex: '-1'
			}} />
		</div>
	);
}